export default {
  data: () => ({
    // loadingMessage: "",
    // isShowLoading: false,
  }),
  methods: {
    backToHome: function () {
      this.$router.push("/");
    },
    showLoading: function (loadingMessage) {
      // this.isShowLoading = true;
      // console.log("showLoading()");

      loadingMessage = loadingMessage ? loadingMessage : "loading data...";
      this.$store.commit("setLoadingMessage", loadingMessage);
      this.$store.commit("setShowLoadingMessage", true);
    },
    hideLoading: function () {
      // this.isShowLoading = false;
      // console.log("loadingMixin().hideLoading()");

      this.$store.commit("setShowLoadingMessage", false);
      // hack because occasionally overlay stays in place,
      // especially when auto-select enabled
      let overlay = document.getElementsByClassName("v-overlay");
      while (overlay.length > 0) {
        overlay[0].parentNode.removeChild(overlay[0]);
      }
    },
    solveOverlay: function () {
      this.$store.commit("hideOverlay");
      if (process.env.VUE_APP_ISDEBUGGING)
        console.log("%c solveOverlay, method:", "color:magenta", {
          method: this.$store.state.overlaySolveMethod,
        });

      if (this.$store.state.overlaySolveMethod != null) {
        if (process.env.VUE_APP_ISDEBUGGING)
          console.log("%c Run overlaySolveMethod.", "color:magenta");

        this.$store.state.overlaySolveMethod();
      }
    },
    showError: function (title, msg) {
      this.hideLoading(); //just in case the error occurs when loading is being displayed.

      let errorMessage = msg
        ? msg
        : "Sorry, we can't find what you are looking for.";
      this.$store.commit("setErrorMessage", {
        title: title,
        message: errorMessage,
      });
      // this.$refs.errorDialogBtn.$el.click();
      if (process.env.VUE_APP_ISDEBUGGING)
        console.log("%c showError", "color:red", title);
    },
  },
};
